"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.detachDirectInsertBorrowingBaseReportUpdate = exports.attachDirectInsertBorrowingBaseReportUpdate = void 0;
const lodash_1 = require("lodash");
const common_1 = require("@finley-technologies/common");
const utils = __importStar(require("../dbNodes/utils"));
const attachDirectInsertBorrowingBaseReportUpdate = (dbGraph) => {
    const clonedDbGraph = (0, lodash_1.cloneDeep)(dbGraph);
    const { dataTapes, dataTapeDependencies } = clonedDbGraph;
    const directInsertBorrowingBaseReports = utils.filterDirectInsertBorrowingBaseReports({ dataTapes });
    if (directInsertBorrowingBaseReports.length === 0) {
        return dbGraph;
    }
    for (const directInsertBorrowingBaseReport of directInsertBorrowingBaseReports) {
        const { artifactSlug, id } = directInsertBorrowingBaseReport;
        const inputTapes = utils.getAllDependencyInputTapes({
            dbGraph,
            outputArtifactId: id,
        });
        const cashResponseTapes = utils.filterCashResponseTapes({
            dataTapes: inputTapes,
        });
        (0, common_1.finleyAssert)(cashResponseTapes.length <= 1, `Direct Insert BorrowingBaseReport can only be created from 0 or 1 cashResponseTape, found ${cashResponseTapes.length} [artifactSlug:${artifactSlug}]`);
        if (cashResponseTapes.length > 0) {
            const cashResponseTape = cashResponseTapes[0];
            // NOTE: this is directly mutating the configuration object.
            // This is safe as we have already deep cloned earlier and this helps simplify the logic
            // without needing to re-create multiple objects through filtering
            directInsertBorrowingBaseReport.configuration.cashResponseTapeArtifactSlug =
                cashResponseTape.artifactSlug;
        }
        else {
            directInsertBorrowingBaseReport.configuration.cashResponseTapeArtifactSlug = null;
        }
    }
    return { dataTapeDependencies, dataTapes };
};
exports.attachDirectInsertBorrowingBaseReportUpdate = attachDirectInsertBorrowingBaseReportUpdate;
const detachDirectInsertBorrowingBaseReportUpdate = (dbGraph) => {
    const updatedDataTapes = dbGraph.dataTapes.map((tape) => {
        if (tape.type !== 'directInsertBorrowingBaseReport') {
            return tape;
        }
        const { cashResponseTapeArtifactSlug: _unused, ...remaining } = tape.configuration;
        return { ...tape, configuration: remaining };
    });
    return {
        dataTapeDependencies: dbGraph.dataTapeDependencies,
        dataTapes: updatedDataTapes,
    };
};
exports.detachDirectInsertBorrowingBaseReportUpdate = detachDirectInsertBorrowingBaseReportUpdate;
//# sourceMappingURL=directInsertBorrowingBaseReport.js.map